module.exports = __webpack_public_path__ + "img/durmstrang_ship_in_black_lake.6e99a90a.jpg";